module.exports = __webpack_public_path__ + "img/win_icon.03d12454.jpg";